import { Box, styled, Typography } from '@mui/material'

export const EmptyContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  border: '1px solid #E4E7EC',
  borderRadius: '8px',
  padding: '3rem 0',
})

export const EmptyMessage = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  color: theme.palette.text.secondary,
  fontSize: '0.9rem',
  fontWeight: 500,
  maxWidth: 600,
  textAlign: 'center',
}))
